import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './style';
import classnames from 'classnames';

const Loader = props => {
  const displayLoader = classnames({ bounceInUp: props.show }, { fadeOutDownBig: !props.show });

  if (props.show) {
    return props.fullLoader ? (
      <styles.FullLoader>
        <i />
      </styles.FullLoader>
    ) : (
      <styles.NormalLoader className={`animated ${displayLoader}`}>
        <span />
        <span>Carregando...</span>
        <div />
      </styles.NormalLoader>
    );
  }

  return null;
};

Loader.propTypes = {
  show: PropTypes.bool.isRequired,
  fullLoader: PropTypes.bool.isRequired,
};

Loader.defaultProps = {
  fullLoader: false,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/index.js